import * as css from "./ResponsiveTable.module.css"

function ResponsiveTable({ children, ...props }) {
  return (
    <div className={css.root}>
      <table className={css.table} {...props}>
        {children}
      </table>
    </div>
  )
}

export default ResponsiveTable
